import ApplyOpportunityBlock from './ApplyOpportunityBlock';

export default ApplyOpportunityBlock;
